import React from 'react'
import {useNavigate} from 'react-router-dom'
import {ModeleClient, modeleClientInitValues} from '../../../../../components/Models'
import {ClientForm} from '../components/ClientForm'
import {createClient} from '../../../../../components/requests'

const ClientAddPage = () => {
  const navigate = useNavigate();
  const submitForm = async (fieldsToUpdate: Partial<ModeleClient>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleClientInitValues}, fieldsToUpdate)

    var requestOk = false;
    try {
      const clientRequest = await createClient(updatedData);
      if (clientRequest?.status === 200) {
        if (clientRequest?.data?.id !== undefined && clientRequest?.data?.id !== null) {
          requestOk = true;
          navigate(`/vente/clients/${clientRequest?.data?.id}/afficher`);
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer un client</h3>
          </div>
        </div>

        <div>
          <ClientForm clientId={null} data={modeleClientInitValues} submitForm={submitForm}/>
        </div>
      </div>
    </>
  )
}

export {ClientAddPage}
